import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { GenderState } from "./gender.state";
import { getGenders, updateGender } from "./gender.thunk";
import { GenderData } from "./gender.types";

const initialState: GenderState = {
  data: null,
  status: "idle",
  error: null,
  updateStatus: "idle",
  updateError: null,
};

const genderSlice = createSlice({
  name: "gender",
  initialState,
  reducers: {
    resetGender: (state) => {
      state.data = null;
      state.status = "idle";
      state.error = null;
      state.updateStatus = "idle";
      state.updateError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getGenders.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(
        getGenders.fulfilled,
        (state, action: PayloadAction<GenderData>) => {
          state.status = "success";
          state.data = action.payload;
        },
      )
      .addCase(
        getGenders.rejected,
        (state, action: PayloadAction<string | undefined>) => {
          state.status = "error";
          state.error = action.payload ?? "Bir hata oluştu.";
        },
      )
      .addCase(updateGender.pending, (state) => {
        state.updateStatus = "loading";
        state.updateError = null;
      })
      .addCase(updateGender.fulfilled, (state) => {
        state.updateStatus = "success";
      })
      .addCase(
        updateGender.rejected,
        (state, action: PayloadAction<string | undefined>) => {
          state.updateStatus = "error";
          state.updateError = action.payload ?? "Bir hata oluştu.";
        },
      );
  },
});

export const { resetGender } = genderSlice.actions;
export default genderSlice.reducer;
